

























































































































import { IDocument } from '@/contract/document.contract';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { extractTranslation, extractTranslationAndReturnFirst } from '../../services/util/translation-extractor';

@Component({})
export default class SearchResultDetailsTable extends Vue {
  @Prop()
  public document!: IDocument;

  public get applicablePTV(): string {
    return extractTranslation(this.document.applicablePTV)?.join(', ') || '/';
  }

  public get applicableSchemeDocument(): string {
    return extractTranslation(this.document.applicableSchemeDocument)?.join(', ') || '/';
  }

  public get applicableStandardSpecification(): string {
    return extractTranslation(this.document.applicableStandardSpecification)?.join(', ') || '/';
  }

  public get applicableTRA(): string {
    return extractTranslation(this.document.applicableTRA)?.join(', ') || '/';
  }

  public get certificateOwner(): string {
    return extractTranslation(this.document.certificateOwner)?.map(_ => _.name).join(', ') || '/';
  }

  public get certifiedProductType(): string {
    return extractTranslation(this.document.certifiedProductType)?.join(', ') || '/';
  }

  public get commercialName(): string {
    return extractTranslation(this.document.commercialName)?.join(', ') || '/';
  }

  public get company(): string {
    return extractTranslation(this.document.company)?.map(_ => _.name).join(', ') || '/';
  }

  public get distributionLocation(): string {
    return extractTranslation(this.document.distributionLocation)?.map(_ => _.name).join(', ') || '/';
  }

  public get executingEntities(): string {
    return extractTranslation(this.document.executingEntities)?.map(_ => _.name).join(', ') || '/';
  }

  public get language(): string {
    return extractTranslation(this.document.language)?.join(', ') || '/';
  }

  public get mark(): string {
    return extractTranslation(this.document.mark)?.join(', ') || '/';
  }

  public get objectType(): string {
      return extractTranslation<string>(this.document.objectType) || '/';
  }

  public get processes(): string {
    return extractTranslation(this.document.processes)?.join(', ') || '/';
  }

  public get processingEntities(): string {
    return extractTranslation(this.document.processingEntities)?.map(_ => _.name).join(', ') || '/';
  }

  public get productGroup(): string {
    return extractTranslation(this.document.productGroup)?.join(', ') || '/';
  }

  public get productionLocation(): string {
    return extractTranslation(this.document.productionLocation)?.map(_ => _.name).join(', ') || '/';
  }

  public get schemeCode(): string {
    return extractTranslation(this.document.schemeCode)?.join(', ') || '/';
  }

  public get services(): string {
    return extractTranslation(this.document.services)?.join(', ') || '/';
  }

  public get snelcode(): string {
    return extractTranslation(this.document.snelcode)?.join(', ') || '/';
  }

  public get specificProcesses(): string {
    return extractTranslation(this.document.specificProcesses)?.join(', ') || '/';
  }

  public get specificProductType(): string {
    return extractTranslation(this.document.specificProductType)?.join(', ') || '/';
  }

  public get specificServices(): string {
    return extractTranslation(this.document.specificServices)?.join(', ') || '/';
  }

  public get subTypeSystem(): string {
    return extractTranslation(this.document.subTypeSystem)?.join(', ') || '/';
  }

  public get systemCode(): string {
    return extractTranslation(this.document.systemCode)?.join(', ') || '/';
  }

  public get typeSystem(): string {
    return extractTranslation(this.document.typeSystem)?.join(', ') || '/';
  }

  public get useCharacteristics(): string {
    return extractTranslation(this.document.useCharacteristics)?.join(', ') || '/';
  }

  public get validDates(): string {
    const startDate = extractTranslationAndReturnFirst(this.document.validFrom) || '/';
    const endDate = extractTranslationAndReturnFirst(this.document.validTo) || '/';
    return `${this.$t('general.from')} ${startDate} ${this.$t('general.to')} ${endDate}`
    }

}
